import {DefaultRootState, useSelector} from 'react-redux';
import {AiAssistantConversation, ChatType} from '../common/types';

export function useStateShowChatSuggestions(): boolean {
    return useSelector(
        (state: DefaultRootState) =>
            state.assistant.showChatSuggestions ?? state.config.uiConfig.aiAssistant.proposeQuestionsEnabled,
    );
}

export function useStateConversation(conversationId: string): AiAssistantConversation | undefined {
    return useSelector((state: DefaultRootState) => state.assistant.conversations[conversationId]);
}

export function useStateConversationsOfChatType(type: ChatType): AiAssistantConversation[] {
    return useSelector((state: DefaultRootState) =>
        Object.values(state.assistant.conversations)
            .filter((value) => value.type === type)
            .values()
            .toArray(),
    );
}
